import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer className="bg-white border-top py-4 mt-auto">
      <div className="container text-center text-muted small">
        <p className="mb-1">
          &copy; {new Date().getFullYear()} <strong>{t('brandName')}</strong> {t('footerRights')}
        </p>
        <p className="mb-0 extra-small text-secondary">
          <i className="bi bi-telephone-outbound me-1"></i> {t('emergencyHelpline')}
        </p>
      </div>
    </footer>
  );
};

export default Footer;
